import React from "react";
import { BedDouble, Bath, Ruler, Mountain } from 'lucide-react';
import { formatArea, formatLotSize } from '../../utils/currency';

var Item = function(props) {
    var label = props.label;
    var value = props.value;
    var Icon = props.icon;

    if (!value) return null;

    return (
        <div className="al-property-stat">
            <div className="al-property-stat-icon">
                <Icon size={20} />
            </div>
            <span className="al-property-stat-value">{value}</span>
            {label && <span className="al-property-stat-label">{label}</span>}
        </div>
    );
};

export var RealEstateDetails = function(props) {
    var auction = props.auction;

    if (!auction) return null;
    if (!auction.isRealEstate) return null;

    var hasStats = auction.bedrooms || auction.bathrooms || auction.livingArea || auction.lotSize;
    if (!hasStats) return null;

    var countryId = auction.countryId;

    // Format area values based on country (includes unit in string)
    var formattedLivingArea = formatArea(auction.livingArea, countryId);
    var formattedLotSize = formatLotSize(auction.lotSize, countryId);

    return (
        <div className="al-property-stats">
            <Item
                label="Beds"
                value={auction.bedrooms}
                icon={BedDouble}
            />
            <Item
                label="Baths"
                value={auction.bathrooms}
                icon={Bath}
            />
            <Item
                value={formattedLivingArea}
                icon={Ruler}
            />
            <Item
                value={formattedLotSize}
                icon={Mountain}
            />
        </div>
    );
};
